'use client';
import Link from 'next/link';
import React, { Component } from 'react';

class Header extends Component {
    render() {
        return (
            <div className='admin_header'>
                <div className='logo_section'>
                    <Link href={'/'} className='top_logo'>Bangla Namaj Shikkha</Link>
                </div>
                <div className='right_section'>
                    <div className='top_user_widget'>
                        <div className='user_avatar'>
                            <i className="fa-regular fa-user"></i>
                        </div>
                    </div>
                    <button type='button' className='btn btn-default logout_btn'><i className="fa-solid fa-power-off"></i></button>
                </div>
            </div>
        );
    }
}

export default Header;